import { faLaptopMobile } from '@fortawesome/pro-solid-svg-icons/faLaptopMobile';
import { faPeopleGroup } from '@fortawesome/pro-solid-svg-icons/faPeopleGroup';
import MobileLinkOutButton from 'studio5/components/AgentStudioLinkOut/MobileLinkOutButton';
import type { LinkOutContent, LinkOutRoute } from './types';

export const TEAM_CONTENT: LinkOutContent = {
  title: 'Team',
  heading: 'Manage your team in the new App',
  message: 'Team settings have moved to the new Appcues App.',
  icon: faPeopleGroup,
};

export const INSTALLATION_CONTENT: LinkOutContent = {
  title: 'Installation',
  heading: 'Install Appcues in the new App',
  message: 'Installation settings have moved to the new Appcues App.',
  icon: faLaptopMobile,
  secondaryAction: MobileLinkOutButton,
};

const routes: LinkOutRoute[] = [
  {
    pattern: /^\/settings\/team\/?$/i,
    resolve: () => '/settings/team',
    content: TEAM_CONTENT,
    examples: ['/settings/team'],
  },
  {
    // `/settings/install` and `/install` redirect here inside classic.
    pattern: /^\/settings\/installation\/?$/i,
    resolve: () => '/settings/apps/web',
    content: INSTALLATION_CONTENT,
    examples: ['/settings/installation'],
  },
];

export default routes;
